import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button, Container, ExpandableContainer, Header, Text } from '@gasbuddy/react-components';
import AmenitiesList from '../AmenitiesList';
import ReviewItem from '../ReviewItem';
import styles from './VerboseStationInfo.module.css';
import { noop } from '../../../lib/utils';

const cx = classnames.bind(styles);

export default function VerboseStationInfo({ stationId, reviews, fetchReviewsByStationId }) {
  React.useEffect(() => {
    fetchReviewsByStationId(stationId);
  }, [fetchReviewsByStationId, stationId]);

  return (
    <ExpandableContainer>
      <Container fluid>
        <Header as="h3" className={cx('dataLabel')} color="midnight">Amenities</Header>
        <AmenitiesList stationId={stationId} expanded={false} />
        <br />
        <Header as="h3" className={cx('dataLabel')} color="midnight">Reviews</Header>
        {reviews.length ? reviews.map(review => (
          <ReviewItem
            key={review.id}
            review={review}
            showReplies
          />
        )) : (
          <Text as="p" color="midnight" italic>No reviews found for station.</Text>
        )}
        <br />
        <Button
          as={Link}
          to={`/Station/${stationId}`}
          primary
          fluid
        >
          View Full Station Details
        </Button>
        <br />
      </Container>
    </ExpandableContainer>
  );
}

VerboseStationInfo.propTypes = {
  stationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  })),
  fetchReviewsByStationId: PropTypes.func,
};

VerboseStationInfo.defaultProps = {
  reviews: null,
  fetchReviewsByStationId: noop,
};
